import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { EditTemplate } from "./EditTemplate";

export default function ViewTemplate({ selectedTemplate, onTemplateEdit, refresh, editedTemplate }) {
  const [template, setTemplate] = useState(null);
  const [templateModalShow, setTemplateModalShow] = useState(false);
  const handleTemplateClose = () => setTemplateModalShow(false);

  useEffect(() => {
    if (!selectedTemplate) return;
    setTemplate(selectedTemplate);
  }, [selectedTemplate]);

  const handleTemplateUpdate = (updatedTemplate) => {
    setTemplate(updatedTemplate);
  }

  return (
    <div>
      {template ? (
        <div>
          {/* 🔹 Edit Button for the Entire Template */}
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fw-normal text-primary">{template.templateTitle}</h5>
            <EditTemplate
              template={selectedTemplate}
              show={templateModalShow}
              onHide={() => {
                setTemplateModalShow(false);
              }}
              templateEdit={onTemplateEdit}
              editedTemplate={handleTemplateUpdate}
              />
          </div>

          <p className="text-primary d-inline">Status: </p>
          <p
            className={`d-inline fw-bold ${
              template.templateStatus === "Active"
                ? "text-success"
                : "text-info"
            }`}
          >
            {template.templateStatus}
          </p>

          {/* 🔹 Section Notes */}
          <Row className="mt-3 mb-3">
            {template.notes?.length > 0 ? (
              template.notes.map((note, index) => (
                <Col md={6} key={index}>
                  <div className="container border shadow-sm rounded pt-2 position-relative p-3">
                    <Form.Group controlId={`section-${index}`}>
                      <Form.Label className="text-primary fw-bold">
                        {note.sessionsSection}
                      </Form.Label>

                      {/* 🔹 Handle Different Field Types */}
                      {note.sessionsFieldType === "text" && (
                        <p
                          className={`mb-1 ${
                            note.sessionsSectionNotes ? "" : "text-muted"
                          }`}
                        >
                          {note.sessionsSectionNotes || "No default value"}
                        </p>
                      )}

                      {note.sessionsFieldType === "textarea" && (
                        <p
                          className={`mb-1 ${
                            note.sessionsSectionNotes ? "" : "text-muted"
                          }`}
                        >
                          {note.sessionsSectionNotes || "No default value"}
                        </p>
                      )}

                      {note.sessionsFieldType === "multiselect" &&
                        Array.isArray(note.sessionsSectionNotes) && (
                          <ul className="m-0 p-0">
                            {note.sessionsSectionNotes.length > 0 ? (
                              note.sessionsSectionNotes.map((option, i) => (
                                <li key={i} className="list-unstyled">
                                  {option}
                                </li>
                              ))
                            ) : (
                              <li className="list-unstyled text-muted">
                                No options selected.
                              </li>
                            )}
                          </ul>
                        )}

                      {note.sessionsFieldType === "image" &&
                        note.sessionsImageURL && (
                          <div className="mt-2">
                            <img
                              src={note.sessionsImageURL}
                              alt="Uploaded"
                              className="img-fluid rounded"
                              style={{ maxHeight: "200px", maxWidth: "100%" }}
                            />
                          </div>
                        )}
                    </Form.Group>
                  </div>
                </Col>
              ))
            ) : (
              <p>No notes available for the selected template.</p>
            )}
          </Row>
        </div>
      ) : (
        <p>Loading template...</p>
      )}
    </div>
  );
}
